import React, { useState, useContext, useEffect } from "react";
import { MenuItem, TextField, Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import baseUrl from "../../../../BaseURL";
import { ContextData } from "../../../../context/Context";
import PopupDialog from "../../../PopupDialog/PopupDialog";
import SettingiewDialogue from "./popDialogue/SettingiewDialogue";
import StateList from "./statesAndLGAs/StateList";
import SoundAlert from "../../../../routes/SoundAlert";

function AddUniversity() {
  // State for form inputs
  const [formData, setFormData] = useState({
    university_name: "",
    state_of_location: "",
    local_government: "",
    foreign_or_local: "",
    institutionCategory: "",
    phone_number: "",
    email: "",
    website: "",
    address: "",
    accreditation: "",
    courses_offered: "",
    about_institution: "",
    other_institution:   ""
  });
  const [DocumentsList, setDocumentsList] = useState(null);
  const [Reload, setReload] = useState(true);
  const { accesstoken } = useContext(ContextData);
  const [institutionList, setInstitutionList] = useState(["Agency", "Polytechnic", "College of Education", "University", "Monotechnic","Institute","College of Nursing", "Priority Area", "Priority Sector", "Priority Course", "Degree" ,"Others"]);

  // Handler for input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handler for file input change
  const handleSubmit = () => {
    // Check for empty fields
    const isEmptyField = Object.values(formData).every((value) => value.trim() === "");

    if (isEmptyField) {
      SoundAlert("error");
      toast.error("Please fill out all fields");
    } else {
      axios.post(`${baseUrl}/auth/add_uni`, formData, {
        withCredentials: true,
        headers: {
          Accept: "application/json",
          'authorization': `Bearer ${accesstoken}`
        },
      })
      .then((res) => {


        if (res.data.status) {
          toast.success(res.data.statusText);
          SoundAlert("success");
          // Reset form after successful submission
      /*     setFormData({
            university_name: "",
            state_of_location: "",
            local_government: "",
            foreign_or_local: "",
            institutionCategory: "",
          }); */
        }if(!res.data.status){
          SoundAlert("error");
          toast.error(res.data.statusText);
        }
        setReload(!Reload);
      })


      .catch((err) => {
        toast.error(err.message);
        setReload(!Reload);
        if (err) return console.log(err.message);
      });
    }
  };




  
  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
      <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-semibold">Add Institution</h2>
       <div className="flex items-center space-x-2 cursor-pointer text-blue-600 hover:text-blue-800">
         <b>View Institutions</b>  <SettingiewDialogue />
       </div>
        </div>
      <form className="space-y-4 text-left">

            <TextField 
            select
            label=" Institution  Category"
            name="institutionCategory"
            value={formData.institutionCategory}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            className="bg-white"
            >
            {institutionList.map((institution)=>(
            <MenuItem key={institution.id} value={institution}>{institution}</MenuItem>
            ))}
            </TextField>


        <TextField
          label="University Name"
          name="university_name"
          value={formData.university_name}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
           inputProps={{ maxLength:  30}}
        />
         
         <TextField 
          label="Phone Number"
          name="phone_number"
          value={formData.phone_number}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
           inputProps={{ maxLength:  11}}
           type="tel"
        />

        <TextField  
          label="Email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
          type="email"
        />

     <p className="font-bold">Type: <span className="text-red-950">N/A</span>  if not available</p>

      <TextField  
          label="Website"
          name="website"
          value={formData.website}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />

         
        <TextField  
          select
          label="Accreditation"
          name="accreditation"
          value={formData.accreditation}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        >
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>

    
 
           <p className="font-bold">Type: <span className="text-red-950">N/A</span>  if not available</p>
           <TextField  
          label="Courses Offered"
          name="courses_offered"
          value={formData.courses_offered}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />


          <TextField  
          label="About Institution"
          name="about_institution"
          value={formData.about_institution}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
          multiline
          rows={4}
        />

        <TextField
          select
          label="Foreign or Local"
          name="foreign_or_local"
          value={formData.foreign_or_local}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        >
          <MenuItem value="foreign">Foreign</MenuItem>
          <MenuItem value="local">Local</MenuItem>
        </TextField>

           <StateList formData={formData} setFormData={setFormData} />

            {
            formData.state_of_location === "Other" && (
              
              <TextField  
               label="Country (if not in Nigeria)"
               name="other_institution"
               value={formData.other_institution}
               onChange={handleChange}
               fullWidth
               variant="outlined"
               className="bg-white"
             />
            )
            }
 

          <TextField  
          label="Address"
          name="address"
          value={formData.address}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
          multiline
          rows={4}
        />
 

        <Button onClick={handleSubmit} variant="contained" color="primary" className="w-full">
          Add
        </Button>
      </form>


    </div>
  );
}

export default AddUniversity;
